import sample_1 from './comet.jpg';

export const comet = {
    sample_1,
};
